/** TODO temporary. will be refactored */

import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Action } from 'redux';
import { merge } from 'rxjs';
import { filter, skip, tap } from 'rxjs/operators';

import { AuthStatus, SecurityScope } from '../auth/auth.model';
import { AuthService } from '../auth/auth.service';
import store from '../store';

import { USER_LIST_MAX_COUNT } from './user.model';

@Injectable({ providedIn: 'root' })
export class SearchUserConfigService {
    scopeId: SecurityScope;
    userListMaxCount: number;
    excludedRoleIds: number[];

    /** @deprecated */
    logoutActions: Action[];

    constructor(
        private readonly _authService: AuthService,
        private readonly _router: Router,
    ) {
        this.scopeId = SecurityScope.USERS;
        this.userListMaxCount = USER_LIST_MAX_COUNT;
        this.excludedRoleIds = [];

        this.logoutActions = [];
        this._clearState();
    }

    /** @deprecated */
    private _clearState(): void {
        merge(
            this._router.events.pipe(
                filter<NavigationEnd>(
                    (event) =>
                        event instanceof NavigationEnd &&
                        event.url === '/logout',
                ),
            ),
            this._authService.authStatus.asObservable().pipe(
                skip(1),
                filter((next) => next === AuthStatus.UNAUTHENTICATED),
            ),
        )
            .pipe(
                tap(() => this.logoutActions.forEach((e) => store.dispatch(e))),
            )
            .subscribe();
    }
}
